import React from 'react';

const LoginCard = ({ children }) => {
  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-card border border-border rounded-2xl shadow-xl p-8 backdrop-blur-sm">
        {children}
      </div>
    </div>
  );
};

export default LoginCard;